import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import i18n from './i18n';
import { validateEnv } from './lib/env';
import { initSentry } from './lib/sentry';

// Validate environment variables early
validateEnv();

// Initialize error monitoring (async, non-blocking)
initSentry();

const renderApp = () =>
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );

// Wait for i18n to be ready before rendering to avoid key flashes
if (i18n.isInitialized) {
  renderApp();
} else {
  i18n.on('initialized', renderApp);
}